import { injectable } from 'inversify';
import { federation_player_full } from '@Api';
import { Player } from '@Models';

@injectable()
export class PlayerMapper {
  public map(item: federation_player_full): Player {
    return {
      id: item.id,
      name: item.name,
      location: {
        latitude: item.location.latitude,
        longitude: item.location.longitude,
      },
    } satisfies Player as Player;
  }
}
